@if(visible()){
<div class="jk-combobox-border">
  <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
    [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  <div>
    <mat-radio-group class="example-radio-group" [(ngModel)]="value" [disabled]="disabled()">
      @for (idNameItem of items(); track idNameItem) {
      <mat-radio-button [value]="idNameItem.id">{{idNameItem.name}}</mat-radio-button>
      }
    </mat-radio-group>
    <!-- <div>{{selectedItem.name}}</div> -->

  </div>

</div>
}